import React, { useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import block from 'bem-cn';

import './SocialMediaDetails.scss';
import SVG from 'components/SVG';
import { socialIcons } from 'features/creativeFunctionality/data';

const b = block('social-media-details-desktop');

const SocialMediaDetails = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { socialMedia } = useSelector(state => state.creativeFunctionality.detailsData);

  if (socialMedia === null) return null;

  return (
    <div className={b()}>
      {socialMedia.old.link && (
        <div className={b('item')}>
          <div className={b('header')}>{locale.wasLink}:</div>
          <div className={b('text')}>
            <SVG className={b('text-icon')} svgProps={{ svg: socialIcons[socialMedia.new.social] }} />
            {socialMedia.old.link}
          </div>
        </div>
      )}
      <div className={b('item')}>
        <div className={b('header')}>{locale.becameLink}:</div>
        <div className={b('text')}>
          <SVG className={b('text-icon')} svgProps={{ svg: socialIcons[socialMedia.old.social] }} />
          {socialMedia.new.link}
        </div>
      </div>
    </div>
  );
};

export default SocialMediaDetails;
